<div class="modal-header">
  <h5 class="modal-title">{{title | translate}}</h5>
  <div class="modal-close-btn" (click)="onDecline()">
    <fa-icon [icon]="['fas','times']"></fa-icon>
  </div>
</div>
<template #container></template>